import React, { FC } from 'react';
import { Dialog, DialogBody, DialogHeader } from '@gravity-ui/uikit';
import { SharePanel } from '../../../SharePanel/SharePanel';
import { VideoInfo } from '../../../../types/video/VideoInfo';
import { dialogsT } from '../../../../i18n';

type ShareVideoDialogProps = {
    isOpen: boolean;
    videoInfo: VideoInfo;
    isMobile?: boolean;
    onClose: () => void;
};

export const ShareVideoDialog: FC<ShareVideoDialogProps> = ({
    isOpen,
    videoInfo,
    isMobile,
    onClose,
}) => {
    return (
        <Dialog
            className={
                isMobile
                    ? 'page-videolist-dialog page-videolist-dialog--mobile'
                    : 'page-videolist-dialog'
            }
            open={isOpen}
            onClose={onClose}
            size="s"
        >
            <DialogHeader caption={dialogsT('shareVideoTitle')} />
            <DialogBody
                className={
                    isMobile
                        ? 'page-videolist-dialog-body page-videolist-dialog-body--mobile'
                        : 'page-videolist-dialog-body'
                }
            >
                <SharePanel contentId={videoInfo.video_id} isMobile={isMobile} />
            </DialogBody>
        </Dialog>
    );
};
